import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditPersonsExtension
 */
@Entity()
export class BaseKPFEditPersonsExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditPersonsExtension';
}
